const commandCenter = {
  title: 'Command Center',
  subheadings: {
    tenant_settings: 'Division Settings',
    internal_details: 'Internal Details',
    tenant_group_details: 'Account Details',
  },
  tabs: {
    tenants: 'Divisions',
    tenantGroups: 'Accounts',
    systems: 'Systems',
    health: 'Service Monitoring',
    health_mobile: 'Health',
    importWizard: 'Import Wizard',
  },
  toast: {
    success: '{{handler}} successfully ({{status}})',
    error: '{{handler}} failed ({{status}})',
    only_the_one: 'Only The One can update this {{name}}',
  },
  services: {
    label: 'Service Status',
    file: 'File Service',
    user: 'User Service',
    vehicle: 'Vehicle Service',
    property: 'Property Service',
    permit: 'Permit Service',
    job: 'Job Service',
    revision: 'Revision Service',
    permitClient: 'Permit Client Service',
    qrCode: 'QR Code Service',
    payment: 'Payment Service',
    redirect: 'Redirect Service',
    analytics: 'Analytics Service',
    findMyCar: 'Find My Car Service',
    notification: 'Notification Service',
    topsPPIAdapter: 'Tops PPI Adapter Service',
  },
  button: {
    copy_tenant: 'Copy Config From: {{name}}',
    copy_tenant_selected: 'Config Copied From: {{name}}',
  },
};

export default commandCenter;
